import React from "react";
import { translate } from "translate/i18n";
import { Tooltip } from "@material-ui/core";

type Status = {
  id: string | number;
  internalDescription: string;
};

type ChangeTicketStatusProps = {
  blockTicket: boolean;
  selectedstatus: any;
  liststatus: Status[];
  handleChange: React.ChangeEventHandler<HTMLSelectElement>;
  handleSave: () => void;
  ticketType: string;
  selectedStatusRealCode: any;
  tooltipWidth: any;
};
export function ChangeTicketStatus(
  props: ChangeTicketStatusProps
): JSX.Element {
  const {
    selectedstatus,
    blockTicket,
    liststatus,
    handleChange,
    handleSave,
    ticketType,
    selectedStatusRealCode,
    tooltipWidth,
  } = props;
  return (
    <>
      <label className="title-combo-details-client-chat">
        {translate("callStatus")}
      </label>
      <div className="form-row">
        <div className="form-group col-lg-8">
          <select
            className="form-control"
            id="example-select"
            value={selectedstatus}
            disabled={blockTicket}
            onChange={handleChange}
          >
            {liststatus.map((data, index) => (
              <option key={index} value={data.id}>
                {data.internalDescription}
              </option>
            ))}
          </select>
        </div>
        <Tooltip
          arrow
          classes={{ tooltip: tooltipWidth }}
          title={translate("setTicketTypeToCloseTicket")}
          disableHoverListener={
            !!ticketType || !isStatusofTypeFinished(selectedStatusRealCode)
          }
        >
          <button
            type="button"
            className="btn btn-outline-success"
            style={{ height: 38 }}
            onClick={handleSave}
            disabled={
              blockTicket ||
              (isStatusofTypeFinished(selectedStatusRealCode) && !ticketType)
            }
          >
            {" "}
            <i className=" uil-exchange"></i> {translate("confirm")}
          </button>
        </Tooltip>
      </div>
    </>
  );
}

function isStatusofTypeFinished(status: any) {
  return String(status) === "4";
}
